export default __webpack_public_path__ + "static/media/girl_home_mobile.e1813641.png";